<template>
  <div class="nav_mobile" :class="{ active: isOpen }">
    <!-- Header with close button -->
    <div class="nav_mobile_header">
      <a href="" class="nav_brand">
        <img :src="'/_resources/app/client/icons/nav_brand.svg'">
      </a>
      <div class="nav_mobile_actions">
        <a :href="orderPageLink" class="nav_mobile_action">
          <img :src="'/_resources/app/client/icons/Cart.svg'" alt="Cart Icon">
        </a>
        <button class="nav_mobile_action" @click="openSearch">
          <img :src="'/_resources/app/client/icons/Search.svg'" alt="Search Icon">
        </button>
        <button class="nav_mobile_close" @click="toggle" aria-label="Close menu">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </button>
      </div>
    </div>

    <!-- Level 1: Main menu -->
    <div class="nav_mobile_level nav_mobile_level--main" >
      <ul class="nav_mobile_menu">
        <li
          v-for="item in mainMenu"
          :key="item.id"
          class="nav_mobile_item"
        >
          <button
            v-if="item.children && item.children.length"
            class="nav_mobile_link"
            @click="openLevel2(item)"
          >
            {{ item.title }}
            <img class="nav_mobile_arrow" :src="'/_resources/app/client/images/navarrow.svg'" alt="Arrow">
          </button>
          <a
            v-else
            :href="item.link"
            class="nav_mobile_link"
          >
            {{ item.title }}
          </a>
        </li>
      </ul>

      <!-- Footer actions -->
      <div class="nav_mobile_footer">
        <a href="#" class="nav_mobile_footer_link" @click="openLanguageMenu">
          <img :src="'/_resources/app/client/icons/Globe.svg'" alt="Language Icon">
          <span>Language</span>
        </a>
        <!--<a href="#" class="nav_mobile_footer_link">
          <img :src="'/_resources/app/client/icons/Group.svg'" alt="Group Icon">
          <span>Login</span>
        </a>-->
        <a href="#" class="nav_mobile_footer_button link--button link--button--contact" @click="contact">
            <img :src="'/_resources/app/client/icons/Phone.svg'" alt="Phone Icon">
            <img :src="'/_resources/app/client/icons/Mail.svg'" alt="Mail Icon">
            <p class="contact_text">Contact Sales</p>
        </a>
      </div>
    </div>

    <!-- Level 2: Submenu -->
    <div class="nav_mobile_level nav_mobile_level--sub" :class="{ active: currentLevel === 2 }">
      <div v-if="activeLevel2" class="nav_mobile_level_content">
        <div class="nav_mobile_level_header">
          <button class="nav_mobile_back" @click="backToLevel1">
            <img class="nav_mobile_arrow" :src="'/_resources/app/client/images/navarrow_back.svg'" alt="Arrow">
            {{ activeLevel2.title }}
          </button>
        </div>

        <ul class="nav_mobile_menu">
          <li
            v-for="item in activeLevel2.children"
            :key="item.id"
            class="nav_mobile_item"
          >
            <button
              v-if="hasLevel3Content(item)"
              class="nav_mobile_link"
              @click="openLevel3(item)"
            >
              {{ item.title }}
              <img class="nav_mobile_arrow" :src="'/_resources/app/client/images/navarrow.svg'" alt="Arrow">
            </button>
            <a
              v-else
              :href="item.link"
              class="nav_mobile_link"
            >
              {{ item.title }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Level 3: Sub-submenu -->
    <div class="nav_mobile_level nav_mobile_level--subsub" :class="{ active: currentLevel === 3 }">
      <div v-if="activeLevel3" class="nav_mobile_level_content">
        <div class="nav_mobile_level_header">
          <button class="nav_mobile_back" @click="backToLevel2">
            <img class="nav_mobile_arrow" :src="'/_resources/app/client/images/navarrow_back.svg'" alt="Arrow">
            {{ activeLevel3.title }}
          </button>
        </div>

        <ul class="nav_mobile_menu">
          <!-- Regular children structure -->
          <template v-if="activeLevel3.children && activeLevel3.children.length">
            <template v-for="item in activeLevel3.children" :key="item.id">
              <!-- Item with children (4th level) - show as group with subheading -->
              <li v-if="item.children && item.children.length" class="nav_mobile_group">
                <a v-if="item.hasContent" :href="item.link" class="nav_mobile_group_title nav_mobile_group_title--link">
                  {{ item.title }}
                </a>
                <div v-else class="nav_mobile_group_title">{{ item.title }}</div>
                <ul class="nav_mobile_submenu">
                  <li v-for="child in item.children" :key="child.id">
                    <a :href="child.link" class="nav_mobile_link">
                      {{ child.title }}
                    </a>
                  </li>
                </ul>
              </li>
              <!-- Item without children - show as regular link -->
              <li v-else class="nav_mobile_item">
                <a
                  :href="item.link"
                  class="nav_mobile_link"
                >
                  {{ item.title }}
                </a>
              </li>
            </template>
          </template>

          <!-- Product page menus structure -->
          <template v-else-if="activeLevel3.isProductPage && activeLevel3.menus">
            <li
              v-for="menu in activeLevel3.menus"
              :key="menu.title"
              class="nav_mobile_group"
            >
              <div class="nav_mobile_group_title">{{ menu.title }}</div>
              <ul class="nav_mobile_submenu">
                <li v-for="link in menu.links" :key="link.url">
                  <a :href="link.url" class="nav_mobile_link">{{ link.title }}</a>
                </li>
              </ul>
            </li>
          </template>
        </ul>

        <!-- Link to the page itself if it has content -->
        <div v-if="activeLevel3.hasContent" class="nav_mobile_menulinks submenu_center_menulinks">
          <a :href="activeLevel3.link" class="link--button link--button--secondary">
            {{ translations.goToPage }} "{{ activeLevel3.title }}"
          </a>
        </div>

        <!-- Menu links (CTA buttons) -->
        <div v-if="activeLevel3.menuLinks && activeLevel3.menuLinks.length" class="nav_mobile_menulinks submenu_center_menulinks">
          <a
            v-for="menuLink in activeLevel3.menuLinks"
            :key="menuLink.url"
            :href="menuLink.url"
            class="link--button link--button--primary"
          >
            {{ menuLink.title }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  menuData: {
    type: Object,
    required: true
  },
  orderPageLink: {
    type: String,
    default: '#'
  },
  translations: {
    type: Object,
    default: () => ({ goToPage: 'Go to page' })
  }
});

const emit = defineEmits(['close', 'openSearch']);

const isOpen = ref(false);
const currentLevel = ref(1);
const activeLevel2 = ref(null);
const activeLevel3 = ref(null);

// Main menu is the top-level children - get all items (including those without children)
const mainMenu = computed(() => {
  if (!props.menuData) return [];

  // Convert object values to array and sort by the sort field
  const items = Object.values(props.menuData);

  // Sort by the 'sort' field from SilverStripe
  return items.sort((a, b) => a.sort - b.sort);
});

// Check if an item has level 3 content
const hasLevel3Content = (item) => {
  return (item.children && item.children.length > 0) ||
         (item.isProductPage && item.menus && item.menus.length > 0) ||
         (item.menuLinks && item.menuLinks.length > 0);
};

// Navigate to level 2
const openLevel2 = (item) => {
  activeLevel2.value = item;
  currentLevel.value = 2;
};

// Navigate to level 3
const openLevel3 = (item) => {
  activeLevel3.value = item;
  currentLevel.value = 3;
};

// Back to level 1
const backToLevel1 = () => {
  currentLevel.value = 1;
  activeLevel2.value = null;
  activeLevel3.value = null;
};

// Back to level 2
const backToLevel2 = () => {
  currentLevel.value = 2;
  activeLevel3.value = null;
};

// Open mobile menu
const open = () => {
  isOpen.value = true;

    //Set class on body to prevent scrolling
    document.body.classList.add('mobile-menu--open');
};

const openLanguageMenu = () => {
  emit('openLanguageMenu');
  document.getElementById('language_modal').showModal();
};


const contact = () => {
  emit('openContact');
  //Find the navbar and in there find a contact-link and trigger click
   const navbar = document.querySelector('.navbar');
    if(navbar) {
        const contactLink = navbar.querySelector('.link--button--contact');
        if(contactLink) {
            contactLink.click();
        }
    }
};

// Toggle mobile menu
const toggle = () => {
    if(isOpen.value) {
        close();
    } else {
        open();
    }
};

// Close mobile menu
const close = () => {
  isOpen.value = false;
  emit('close');
  // Reset to level 1 after closing
  setTimeout(() => {
    currentLevel.value = 1;
    activeLevel2.value = null;
    activeLevel3.value = null;
  }, 300);

    //Remove class on body to allow scrolling
    document.body.classList.remove('mobile-menu--open');
};

// Open search
const openSearch = () => {
  emit('openSearch');
  close();
};

// Expose methods for parent component
defineExpose({
  open,
  close,
  toggle
});
</script>
